import { useTranslation } from 'react-i18next';

const RewardsSection = ({ lang }) => {
    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    return (

        <section>
            <div className="mt-6 mb-5 c-discover-rewards mb-md-80">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-4 d-none d-xl-block">
                            <div className="o-cont-fullw__left c-discover-rewards__img">
                                {/* <img src="/images/web/bedloop-nofoto.png" alt="" />*/}
                                {/* <img src="https://pro-static.h10hotels.com/gallery/T11D3/H10Rewards_HomeH10v3.jpg" alt="" />*/}
                                <img src="/images/web/valesuites/pareja-vino-rewards_ok.png" alt="" />
                            </div>
                        </div>
                        <div className="col-xl-8">
                            <h3 className="mb-3 fw-light h2">
                                <p className="nolineheight">
                                    <span style={{ color: "rgb(150, 113, 38)" }} > Rewards</span>
                                </p>
                                <p className="nolineheight">{t("DONDE SIEMPRE ERES BIENVENIDO")}</p>
                            </h3>
                            <p className="text-md fst-xl-italic" className="noliheheight">
                                {t("Nuestro programa de fidelización te abre las puertas a un mundo de ventajas, descuentos directos y trato exclusivo para que disfrutes.")}
                            </p>

                            <ul className="row o-list-features">
                                <li className="col-12 col-sm-6 col-md-3">
                                    <img loading="lazy" src="https://pro-static.h10hotels.com/gallery/H10Rewards_Icono_DESCUENTO_Negro.svg" alt="" />
                                    <span>
                                        <p className="nolineheight">
                                            <strong>{t("5% de descuento")}</strong> {t("desde la primera reserva")}
                                        </p>
                                    </span>
                                </li>
                                <li className="col-12 col-sm-6 col-md-3">
                                    <img loading="lazy" src="https://pro-static.h10hotels.com/gallery/H10Rewards_Icono_TARJETA_Negro.svg" alt="" />
                                    <span>
                                        <p className="nolineheight">{t("Acumula")} <strong>{t("puntos y canjéalos")}</strong> {t("por estancias")} </p>
                                    </span>
                                </li>
                                <li className="col-12 col-sm-6 col-md-3">
                                    <img loading="lazy" src="https://pro-static.h10hotels.com/gallery/H10Rewards_Icono_NOCHE_Negro.svg" alt="" />
                                    <span>
                                        <p className="nolineheight">{t("Benefíciate de promociones exclusivas y ")}<strong>{t("noches gratis")}</strong>
                                        </p>
                                    </span>
                                </li>
                                <li className="col-12 col-sm-6 col-md-3">
                                    <img loading="lazy" src="https://pro-static.h10hotels.com/gallery/H10Rewards_Icono_REGALO_Negro.svg" alt="" />
                                    <span>
                                        <p className="nolineheight">{t("Disfruta de tu")} <strong>{t("obsequio de bienvenida")}</strong> {t("y atenciones especiales")} </p>
                                    </span>
                                </li>

                            </ul>
                            <div className="mt-5 text-center text-xl-start mb-xl-4">
                                <a className="mx-auto btn btn-rewards" href={`/${preidioma}${t("rewards")}`}>{t("DESCUBRE REWARDS")}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section >

    );
}

export default RewardsSection;

